function createQueryStr(params){
    return Object.keys(params)
        .map(key => [key, params[key]]
            .map(encodeURIComponent).join('=')).join('&');
}
function params(key, exact){
    update();
    var params = URL.info["params"];

    if (isPresent(key)){
        var output = null;
        if (!exact) key = key.toLowerCase();
        loopProps(params, function(name, value){
            if (!exact) name = name.toLowerCase();
            if (key === name) {
                output = value;
                return true;
            }
        });
        return output;
    }
    return params;
}
function process(options = {}) {
    var {
        domain = window.location.origin,
        path = "",
        persist = false,
        routes = [],
        search = trimChar(window.location.search, "?"),
        url = window.location.toString()
    } = options;

    var output = {};

    if (isPresent(path)) {
        // Remove domain name from path string
        path = path.replace(domain, "");

        // Extract the params
        [path, search] = path.split("?");
    } else {
        // Proceed with url
        path = trimSlashes(window.location.pathname);

        output["url"] = url;
        output["domain"] = domain;
    }

    output["path"] = path;
    output["route"] = null;

    var params = {};

    if (isPresent(routes)) {
        forLoop(routes, function(routeStr){
            var route = URL.routeMatch(routeStr, path);
            if (route.match) {
                output["route"] = routeStr;
                params = Object.assign(params, route.params);
                return true;
            }
        });
    }

    var query = search.split("&");
    var hasQuery = query.length > 0;
    hasQuery = (hasQuery && isPresent(query[0])) || query.length > 1;

    if (hasQuery){
        forLoop(query, function (param) {
            var name, value;
            [name, value] = param.split("=");
            value = decodeURIComponent(value);
            params[name] = value;
        });
    }

    output["params"] = params;
    output["urlNoParams"] = `${output["domain"]}/${output["path"]}`;

    if (persist) URL.info = output;

    return output;
}
function update(){
    URL.process({persist: true});
}

/**
 * @alias Plastic.URL
 */
var URL = {
    dependencies: ["Helpers"],
    get domain(){return window.location.hostname;},
    get path(){
        return process().path
    },
    info: {params: {}},
    addQueryString: function(pathStr){
        update();
        return `${pathStr}?${URL.queryStr()}`;
    },
    init: function(){

    },
    params: params,
    process: process,
    push: function(options, preserveQuery){
        var {
            state = {},
            title = "",
            url = ""
        } = options;

        if (preserveQuery){
            url = URL.addQueryString(url);
        }

        window.history.pushState(state, title, url);
    },
    pushParams: function(params, replace){
        update();

        params = mergeObjects(URL.params(), params);

        var url = `${URL["info"]["urlNoParams"]}?${URL.queryStr(params)}`;
        var title = document.title;
        if (replace) window.history.replaceState({}, title, url);
        else window.history.pushState({}, title, url);
    },
    queryStr: function(params){
        params = isSetOr(params, URL.params());

        return createQueryStr(params);
    },
    routeMatch: function(route, path){
        var output = {
            match: false,
            params: {}
        };

        // Escape all non template characters
        let routeRegex = route.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

        // Replace placeholders with wildcards
        routeRegex = routeRegex.replace(new RegExp("({(.*?)})", "g"), "([^\/]+)");

        // Create a search Regex
        routeRegex = new RegExp(`^${routeRegex}$`);

        // Check for match
        if (routeRegex.test(path.toLowerCase())){
            output.match = true;
            var routePieces = route.split("/");
            var pathPieces = path.split("/");
            for (var i = 0; i < routePieces.length; i++){
                let part = routePieces[i];
                if ((new RegExp("({(.*?)})", "g")).test(part)){
                    part = trimChar(part, "{}");
                    output.params[part] = pathPieces[i];
                }
            }
        }

        return output;
    }
};
